var map = {
	"./_placeholder.svg": 34,
	"./add.svg": 35,
	"./arrow-back.svg": 36,
	"./arrow-forward.svg": 37,
	"./autoloadit.svg": 38,
	"./autoworks.svg": 39,
	"./close.svg": 40,
	"./error.svg": 41,
	"./fullscreen-exit.svg": 42,
	"./fullscreen.svg": 43,
	"./logo.svg": 44,
	"./mute.svg": 45,
	"./navigate-next.svg": 46,
	"./navigate-previous.svg": 47,
	"./pause.svg": 48,
	"./photo.svg": 49,
	"./play.svg": 50,
	"./refresh.svg": 51,
	"./remove.svg": 52,
	"./rotate-camera.svg": 53,
	"./three-sixty.svg": 54,
	"./touch.svg": 55,
	"./video.svg": 56,
	"./volume-down.svg": 57,
	"./volume-up.svg": 58,
	"./warning.svg": 59,
	"./zoom-in.svg": 60
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;